(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  function setExpanded(details, expanded) {
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeDetails(details) {
    details.removeAttribute('open');
    setExpanded(details, false);
  }

  function openDetails(details) {
    if (!desktopQuery.matches) return;
    document.querySelectorAll('.vr-main-nav details[open]').forEach((openDetail) => {
      if (openDetail !== details) closeDetails(openDetail);
    });
    details.setAttribute('open', '');
    setExpanded(details, true);
  }

  function initHeaderMegaMenus() {
    const detailsItems = document.querySelectorAll('.vr-main-nav details');
    if (!detailsItems.length) return;

    detailsItems.forEach((details) => {
      let closeTimer;
      const categoryItems = details.querySelectorAll('.vr-mega-menu__category-item.has-children');

      details.addEventListener('pointerenter', () => {
        window.clearTimeout(closeTimer);
        openDetails(details);
      });

      details.addEventListener('pointerleave', () => {
        closeTimer = window.setTimeout(() => closeDetails(details), 120);
      });

      details.addEventListener('focusin', () => openDetails(details));

      details.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!details.contains(document.activeElement)) closeDetails(details);
        }, 0);
      });

      categoryItems.forEach((item) => {
        let childCloseTimer;

        item.addEventListener('pointerenter', () => {
          window.clearTimeout(childCloseTimer);
          categoryItems.forEach((categoryItem) => {
            if (categoryItem !== item) categoryItem.classList.remove('is-open');
          });
          item.classList.add('is-open');
        });

        item.addEventListener('pointerleave', () => {
          childCloseTimer = window.setTimeout(() => item.classList.remove('is-open'), 120);
        });

        item.addEventListener('focusin', () => {
          categoryItems.forEach((categoryItem) => {
            if (categoryItem !== item) categoryItem.classList.remove('is-open');
          });
          item.classList.add('is-open');
        });

        item.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!item.contains(document.activeElement)) item.classList.remove('is-open');
          }, 0);
        });
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.vr-main-nav details[open]').forEach((details) => {
        closeDetails(details);
        details.querySelector('summary')?.focus();
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.vr-main-nav')) return;
      document.querySelectorAll('.vr-main-nav details[open]').forEach(closeDetails);
    });

    desktopQuery.addEventListener('change', () => {
      document.querySelectorAll('.vr-main-nav details[open]').forEach(closeDetails);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderMegaMenus);
  } else {
    initHeaderMegaMenus();
  }
})();
